import React, { useMemo } from 'react';
import { css } from "@emotion/react";

import { useAppState } from "core/contexts/AppContext";
import theme from "theme/index";

const CartPromoCodes = () => {
    const [appState] = useAppState();

    const discountCodes = useMemo(() => {
        if (!appState.cart?.discounts) return "";

        const labels: string[] = [];
        try {
            const discounts = JSON.parse(appState.cart.discounts);
            for (const key in discounts) {
                if (discounts.hasOwnProperty(key) && Array.isArray(discounts[key])) {
                    labels.push(discounts[key]);
                }
            }

            return labels.flat().join(', ');
        } catch (error) {
            return "";
        }
    }, [appState.cart?.discounts]);

    if (!discountCodes) {
        return null;
    }

    const hasMultipleCodes = discountCodes.includes(",");

    const containerStyle = css`
        padding: 10px 7px;
        height: 42px;
    `;

    const discountCodeStyle = css`
        font-weight: ${theme.fonts.weights.bold};
    `;

    return (
        <div css={containerStyle}>
            Promo code{hasMultipleCodes && "s"}: <span css={discountCodeStyle}>{discountCodes}</span>
        </div>
    );
}

export default CartPromoCodes;
